var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 60,
    viewBox: "0 0 58 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.45 14.1L29.45 0.0999951C29.17 -0.0400049 28.84 -0.0400049 28.56 0.0999951L0.55 14.1C0.21 14.27 0 14.62 0 14.99V58.99C0 59.54 0.45 59.99 1 59.99H57C57.55 59.99 58 59.54 58 58.99V14.99C58 14.61 57.79 14.26 57.45 14.1Z",
    fill: "#DADFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 19.99H8C7.44772 19.99 7 20.4377 7 20.99V58.99C7 59.5423 7.44772 59.99 8 59.99H50C50.5523 59.99 51 59.5423 51 58.99V20.99C51 20.4377 50.5523 19.99 50 19.99Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 41.99H8C7.45 41.99 7 42.44 7 42.99V59.99H25V42.99C25 42.44 24.55 41.99 24 41.99Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 45.99H22C21.45 45.99 21 46.44 21 46.99V59.99H39V46.99C39 46.44 38.55 45.99 38 45.99Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 41.99H13V47.99C13 48.54 13.45 48.99 14 48.99H18C18.55 48.99 19 48.54 19 47.99V41.99Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 45.99H27V51.99C27 52.54 27.45 52.99 28 52.99H32C32.55 52.99 33 52.54 33 51.99V45.99Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 19.99H8C7.44772 19.99 7 20.4377 7 20.99V24.99C7 25.5423 7.44772 25.99 8 25.99H50C50.5523 25.99 51 25.5423 51 24.99V20.99C51 20.4377 50.5523 19.99 50 19.99Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 23.99H51V29.99H7V23.99Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 27.99H51V31.99H7V27.99Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 9.99001H22C21.4477 9.99001 21 10.4377 21 10.99V14.99C21 15.5423 21.4477 15.99 22 15.99H36C36.5523 15.99 37 15.5423 37 14.99V10.99C37 10.4377 36.5523 9.99001 36 9.99001Z",
    fill: "#027BC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 59.99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.87555a5ed8fc663cbaf01ece91b07615.svg";
export { ForwardRef as ReactComponent };